import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';
import { patchInspection, postInspectionAction } from 'src/features/bookings/api';

import { InspectionAction } from '../components/enum/inspection-action';
import { CleanType } from '../components/enum/clean-type';

export const useHousekeepingOptIn = (
    inspectionId: string,
    config?: MutationOptions<
        void,
        AxiosError<ConciergeErrorResponse>,
        { preferredCleaningTime: string; academicYear: string; cleanType: CleanType }
    >
) =>
    useMutation<
        void,
        AxiosError<ConciergeErrorResponse>,
        { preferredCleaningTime: string; academicYear: string; cleanType: CleanType }
    >({
        mutationKey: ['housekeeping', InspectionAction.OPT_IN],
        mutationFn: async ({ academicYear, cleanType, preferredCleaningTime }) => {
            await patchInspection(inspectionId, academicYear, preferredCleaningTime, cleanType);
            await postInspectionAction(inspectionId, academicYear, InspectionAction.OPT_IN);
        },
        ...config,
    });
